import React, { use, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addHearingType } from 'slices/hearingTypeSlice';
import { updateHearingType } from 'slices/hearingTypeSlice';
import toast from 'react-hot-toast';
import { hearingTypeSelector } from 'slices/hearingTypeSlice';
import { setError } from 'slices/hearingTypeSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { fetchHearingTypes } from 'slices/hearingTypeSlice';
import { fetchCaseTypes } from 'slices/caseTypeSlice';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';

const AddHearingTypesForm = ({ item, handleClose, callback, statusPerm }) => {
  const { handleSubmit, formState: { errors }, control, setValue, } = useForm();
  const dispatch = useDispatch();
  const { error, loader } = useSelector(hearingTypeSelector);
  const [filterCaseType, setFilterCaseType] = useState({});

  useEffect(() => {
    setValue('name', item?.name || '');
    setValue('case_type_id', item?.case_type_id || null)
    setValue('minimum_hours', item?.minimum_hours || 2)
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    return () => {
      dispatch(setError({}))
      setFilterCaseType(null)
      setValue("name", "")
      setValue("status", 1)
      setValue("case_type_id", null)
      setValue('minimum_hours', 2)
    }
  }, [item])


  useEffect(() => {
    if (item?.case_type?.name && item?.case_type?.id) {
      setFilterCaseType({
        label: item?.case_type?.name || "",
        value: item?.case_type?.id || ""
      })
    } else {
      setFilterCaseType(null)
    }
  }, [item?.case_type])


  const filteredCaseTypeLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchCaseTypes(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchHearingTypes())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateHearingType(data, item?.id, submitCallback));
    } else {
      dispatch(addHearingType(data, submitCallback));
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>

      <div className="row-primary">
        <h2>Type name *</h2>

        <Controller
          name="name"
          control={control}
          render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Location Name' required {...field} />}
        />
      </div>

      {/* CASE TYPE SELECT */}
      <div className="row-primary">
        <h2>Select Case Type *</h2>
        <div className="w-100">
          <Controller
            name="case_type_id"
            control={control}
            rules={{
              required: "Please select a case type",
            }}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement="auto"
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={filterCaseType}
                  loadOptions={filteredCaseTypeLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    if (obj?.value) {
                      setFilterCaseType(obj);
                      field.onChange(obj.value);
                    } else {
                      setFilterCaseType(null);
                      field.onChange(null);
                    }
                  }}
                  additional={{
                    page: item?.state?.id ? 2 : 1,
                  }}
                />
                {errors?.language_id?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.language_id?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>
      </div>

      <div className="row-primary">
        <h2>Minimum Hour*</h2>
        <div style={{ width: "100%" }}>
          <Controller
            name={`minimum_hours`}
            control={control}
            rules={{
              required: "Please enter minimum hour"
            }}
            render={({ field }) => (
              <input className="input-in type_inp"
                type="number"
                name='minimum_hours'
                min={0}
                placeholder='Name' required
                // value={field.value}
                {...field}

              />
            )}
          />
          {
            errors?.minimum_hours?.length && errors?.minimum_hours?.message &&
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={errors?.minimum_hours?.message} />
            </div>
          }

        </div>
      </div>

      {statusPerm &&
        <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
          <h2 className='mt-0'>Status</h2>
          <Controller
            name="status"
            control={control}
            required
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CustomSwitch
                labelText="active"
                checked={field.value == 1 ? true : false}
                handleChange={(checked) => field.onChange(checked ? 1 : 0)}

              />
            )}
          />
        </div>
      }
      {error?.errors?.name?.map((error) => (
        <div style={{ marginBottom: 10 }}>
          <ErrorMessage text={error} />
        </div>
      ))}

      <div className="Form-footer">
        <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
        <SubmitButton
          loader={loader}
          btnText={item?.id ? "Update" : "Create"}
        />
      </div>
    </form>
  )
}

const AddHearingTypes = ({ item, onClose, callback, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Hearing Type</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddHearingTypesForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddHearingTypes
